// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3yGXH","label":"Labeled_label__lBMvd","divider":"Labeled_divider__36QKf"};